import { Transaction } from "@solana/web3.js";
import { AxiosInstance, AxiosResponse } from "axios";

import { SerializedTransactionsWithSetup } from "../../types";
import { base64 } from "../bytes";

export function deserializeLegacyTransaction(serializedTransaction: string): Transaction {
    const transaction = Transaction.from(base64.decode(serializedTransaction));
    return transaction;
}

export async function fetchLegacyTransactionsWithSetup<BodyType>(
    api: AxiosInstance,
    url: string,
    data?: BodyType
): Promise<SerializedTransactionsWithSetup> {
    const response = await api.post<BodyType, AxiosResponse<SerializedTransactionsWithSetup>>(url, data);
    return response.data;
}
